<template>
  <v-container class="pb-0">
    <div class="mt-0 mb-2" style="display:flex;flex-direction:row;align-items:center;">
      <div class="mr-5">
        <v-btn @click="volver()" icon color="white">
          <v-icon large>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <div>
        <h2
          class="grey--text text--lighten-3"
          style="font-size: 25pt;"
        >Registrarme como Comprador(a)</h2>
        <!-- <p class="grey--text text--lighten-2 mb-0" style="font-size: 15pt;">
          Construyamos juntos el calendario de suministro mas grande de Colombia. Al registrarte ayudaremos a promover tu cultivo, encontrar apoyo para los principales problemas de tu finca y te conectaremos con las mejores oportunidades.
        </p>-->
      </div>
    </div>
    <div>
      <v-stepper
        v-model="stepperRegistro"
        vertical
        :style="{background: $vuetify.theme.themes.dark.secondary}"
      >
        <v-stepper-step step="1" :complete="stepperRegistro > 1">
          <span style="line-height: 30px;">¿Que producto demandas?</span>
          <small>A registrar tu demanda podrás contactarte directamente con productores que cumplen tus requisitos</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <div class="mb-3">
            <div>
              <v-form ref="formProducto">
                <!-- Seleccion Producto -->
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="registroComprador.demanda.producto"
                      :items="productos"
                      chips
                      clearable
                      hide-details="auto"
                      hide-selected
                      item-text="nombre"
                      item-value="idProducto"
                      label="¿Que producto necesitas?"
                      outlined
                      return-object
                      :rules="[rules.required]"
                    >
                      <template v-slot:selection="{ attr, on, item, selected }">
                        <v-chip
                          pill
                          v-bind="attr"
                          :input-value="selected"
                          :color="item.imagen.colors[2][0]"
                          class="white--text"
                          v-on="on"
                        >
                          <v-avatar left>
                            <v-img :src="item.imagen.url"></v-img>
                          </v-avatar>
                          <span v-text="item.nombre"></span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.nombre"></v-list-item-title>
                          <v-list-item-subtitle
                            v-if="item.tipoProducto=='agricola'&&item.categoria"
                            v-text="item.categoria.categoriaGeneral.nombre"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle v-else>Producto Pecuario</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <p
                  class="mb-0 mt-2"
                  style="padding:0;font-size:12pt;height: 40px;color: hsla(0,0%,100%,.7);"
                >
                  Volumen Aproximado de Demanda
                  <span
                    v-if="registroComprador.demanda.producto"
                  >de {{registroComprador.demanda.producto.nombre}}</span>
                </p>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.demanda.frecuencia"
                      item-text="nombrePeriodicidad"
                      :items="variablesForm.unidadesFrecuencia"
                      return-object
                      label="Frecuencia"
                      name="frecuencia"
                      :rules="[rules.required]"
                      hide-details="auto"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.demanda.volumen.unidad"
                      item-text="Name.Plu.es"
                      :items="variablesForm.unidadesPeso"
                      return-object
                      label="Unidad Volumen"
                      name="unidadExtension"
                      hide-details="auto"
                      :rules="[rules.required]"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-if="registroComprador.demanda.volumen.unidad"
                      v-model="registroComprador.demanda.volumen.valor"
                      label="Cantidad"
                      outlined
                      :suffix="registroComprador.demanda.volumen.unidad.Name.Plu.es"
                      name="extension"
                      type="number"
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="registroComprador.demanda.producto&&registroComprador.demanda.producto.porciones"
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                  >
                    <v-select
                      v-model="registroComprador.demanda.porcion"
                      hide-details="auto"
                      item-text="presentacionCompleta.sin"
                      :items="registroComprador.demanda.producto.porciones"
                      label="Porción de producto"
                      outlined
                      chips
                      clearable
                      return-object
                    ></v-select>
                  </v-col>
                </v-row>

                <p
                  class="mb-0 mt-2"
                  style="padding:0;font-size:12pt;height: 40px;color: hsla(0,0%,100%,.7);"
                >¿De que departamentos quieres recibir ofertas de productores?</p>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-select
                      v-model="registroComprador.demanda.ubicaciones"
                      hide-details="auto"
                      item-value="id_departamento"
                      item-text="nombre"
                      :items="variablesForm.departamentos"
                      label="Selecciona uno o varios departamentos"
                      multiple
                      outlined
                      chips
                      clearable
                      :rules="[rules.requiredMultiple]"
                      return-object
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="registroComprador.demanda.informacionExtra"
                      label="Cuentanos un poco más de las especificaciones u otros productos que necesitas:"
                      auto-grow
                      outlined
                      rows="3"
                      hide-details="auto"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-btn class="mt-4" color="primary" @click="continuarEmpresaStepper">Continuar</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="stepperRegistro > 2">
          <span style="line-height: 30px;">Cuéntanos sobre tu empresa</span>
          <small>Nombre, Tipo de Empresa, Ubicación</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <div>
            <div>
              <v-form ref="formFinca">
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-model="registroComprador.empresa.nombre"
                      label="Nombre Empresa"
                      type="text"
                      :rules="[rules.required]"
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-model="registroComprador.empresa.nit"
                      label="NIT Empresa"
                      type="text"
                      :rules="[rules.required]"
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.empresa.tipoEmpresa"
                      item-text="nombre"
                      return-object
                      :items="variablesForm.tiposEmpresa"
                      label="Tipo Empresa"
                      hide-details="auto"
                      outlined
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-subheader style="padding:0;font-size:12pt;">Ubicación</v-subheader>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.empresa.ubicacion.pais"
                      item-text="nombre_pais"
                      item-value="id_pais"
                      return-object
                      :items="variablesForm.paises"
                      label="Pais"
                      hide-details="auto"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.empresa.ubicacion.departamento"
                      item-value="id_departamento"
                      item-text="nombre"
                      :items="variablesForm.departamentos"
                      label="Departamento"
                      @change="getCiudades(registroComprador.empresa.ubicacion.departamento)"
                      name="departamento"
                      outlined
                      return-object
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.empresa.ubicacion.ciudad"
                      :items="variablesForm.municipios"
                      :rules="[rules.required]"
                      item-value="id_ciudad"
                      item-text="nombre_ciudad"
                      label="Ciudad"
                      outlined
                      return-object
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                      v-model="registroComprador.empresa.ubicacion.direccion"
                      label="Dirección"
                      type="text"
                      :rules="[rules.required]"
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div class="mt-4">
              <v-btn color="primary" @click="continuarUsuarioStepper">Continuar</v-btn>
              <v-btn text @click="stepperRegistro=1">Atrás</v-btn>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-step step="3">
          <span style="line-height: 30px;">Cuéntanos sobre ti</span>
          <small>Tu nombre e información de contacto</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <div>
            <div>
              <v-form ref="formUsuario">
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="registroComprador.usuario.nombres"
                      label="Nombres"
                      name="nombre"
                      outlined
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="registroComprador.usuario.apellidos"
                      label="Apellidos"
                      name="apellidos"
                      outlined
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.usuario.documento.tipo"
                      item-value="id"
                      item-text="nombre"
                      :items="variablesForm.tiposDocumento"
                      return-object
                      label="Tipo de Documento"
                      outlined
                      hide-details="auto"
                    >
                      <template v-slot:selection="{item}">
                        <span>{{ item.abr }}</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="8" lg="8" xl="8">
                    <v-text-field
                      v-model="registroComprador.usuario.documento.numero"
                      label="N° Documento"
                      prepend-icon="mdi-account-card-details-outline"
                      outlined
                      name="documento"
                      type="number"
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-model="registroComprador.usuario.telefono"
                      label="Celular"
                      prepend-icon="mdi-phone"
                      outlined
                      name="celular"
                      :rules="[rules.required]"
                      type="number"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-dialog
                      ref="dialog"
                      v-model="modalFechaNacimiento"
                      :return-value.sync="date"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormatted"
                          label="Fecha de Nacimiento"
                          prepend-icon="mdi-calendar-today"
                          readonly
                          outlined
                          v-on="on"
                          hide-details="auto"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="pickerBirthday"
                        locale="es"
                        v-model="date"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1940-01-01"
                        scrollable
                      >
                        <div class="flex-grow-1"></div>
                        <v-btn text color="primary" @click="modalFechaNacimiento = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="registroComprador.usuario.sexo"
                      item-text="sexo"
                      item-value="id"
                      :items="variablesForm.sexos"
                      return-object
                      label="Sexo"
                      outlined
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="registroComprador.usuario.correo"
                      label="Correo Electronico"
                      prepend-icon="mdi-email-outline"
                      outlined
                      type="email"
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="registroComprador.usuario.password"
                      :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                      label="Contraseña"
                      prepend-icon="mdi-lock"
                      outlined
                      :type="showPass ? 'text' : 'password'"
                      :rules="[rules.required,min]"
                      @click:append="showPass = !showPass"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Productor -->
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-select
                      v-model="registroComprador.origenRegistro"
                      item-text="nombre"
                      :items="origen"
                      return-object
                      label="Como llegaste a Cultivando Futuro"
                      outlined
                      chips
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <!-- Terminos y Condiciones -->
              <v-row class="px-2" align="center" justify="center">
                <v-checkbox class="mt-0" v-model="terminosCondiciones">
                  <template v-slot:label>
                    <div>
                      Acepto los
                      <a
                        target="_blank"
                        href="https://app.cultivandofuturo.com/documentos-legales/terminos-condiciones"
                        @click.stop
                      >Terminos y Condiciones de uso</a>
                    </div>
                  </template>
                </v-checkbox>
              </v-row>
            </div>
            <v-btn
              color="primary"
              large
              @click="finalizarRegistro()"
              :loading="loading"
            >Finalizar Registro</v-btn>
            <v-btn text large @click="stepperRegistro=2">Atrás</v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>

      <v-row>
        <v-col>
          <p
            class="grey--text text--lighten-1 mb-0 mt-1"
          >Copyright © 2014-2020 Cultivando Futuro S.A.S - agro@cultivandofuturo.com</p>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
    >{{ snackbar.text }}</v-snackbar>
    <v-dialog v-model="dialogCodigo" persistent max-width="500px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title>
          <v-col class="pb-0">
            <span style="font-weight: 600;font-size: 20pt;">Registro Exitoso</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt;">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt;line-height: 28px;"
                >
                  ¡Ahora haces parte de la comunidad agro mas grande del país! Bienvenido a
                  <b>Cultivando Futuro</b>
                </p>
                <p
                  class="mb-2 grey--text text--lighten-4"
                >Para validar tu cuenta te enviamos un SMS a tu teléfono.</p>
                <p
                  class="mb-0 grey--text text--lighten-4"
                >Por favor digita el código a continuación:</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-form ref="codigoCognito">
                  <v-text-field
                    v-model="codigoCognito"
                    label="Codigo SMS"
                    outlined
                    :rules="[rules.required,rules.counter6]"
                    type="number"
                  ></v-text-field>
                </v-form>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn
                :loading="loadingCodigo"
                @click="confirmAccount()"
                large
                color="primary"
              >Validar mi cuenta</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCodigoConfirmacion" persistent max-width="500px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title>
          <v-col class="pb-0">
            <span style="font-weight: 600;font-size: 20pt;">Registro Exitoso</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt;">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt;line-height: 28px;"
                >
                  ¡Ahora haces parte de la comunidad agro mas grande del país! Bienvenido a
                  <b>Cultivando Futuro</b>!
                  <br />
                  <br />Cada vez que un productor se registre en la plataforma y haga
                  <b>match</b> con tu demanda serás notificado, además de poder ingresar a tu perfil en nuestra plataforma ingresando a
                  <a href="https://app.cultivandofuturo.com">app.cultivandofuturo.com</a>
                </p>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn @click="volverInicio()" color="primary">Volver al Calendario</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErrorRegistro" persistent max-width="550px">
      <v-card dark color="error">
        <v-card-title style="font-weight: 600;font-size: 20pt;">
          <v-col class="pb-0">{{textError}}</v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt;">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt;line-height: 28px;"
                >
                  Hubo un error inesperado en tu registro, por favor notificanos de este error escribiendo a nuestro
                  <b>
                    <a
                      href="https://wa.me/573057381660?text=Tengo%20un%20problema%20en%20mi%20registro%20de%20Cultivando%20Futuro"
                      style="color:white"
                    >Whatsapp</a>
                  </b>
                  <br />
                  <br />O vuelve a la página de Inicio de
                  <a
                    href="https://cultivandofuturo.com"
                    style="color:white"
                  >Cultivando Futuro</a>.
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const { DateTime } = require("luxon");

import api from "@/api/api.js";

import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "RegistrarComprador",
  components: {
    HelloWorld,
  },
  data: () => ({
    stepperRegistro: 1,
    productos: [],
    registroComprador: {
      demanda: {
        producto: null,
        frecuencia: null,
        volumen: {
          valor: null,
          unidad: null,
        },
        porcion: null,
        ubicaciones: null,
        informacionExtra: null,
      },
      empresa: {
        nombre: null,
        nit: null,
        tipoEmpresa: null,
        ubicacion: {
          pais: {
            id_pais: 42,
            iso_pais: "CO",
            nombre_pais: "Colombia",
            codigoPais: "+57",
            emoji: "🇨🇴",
          },
          departamento: null,
          ciudad: null,
          direccion: null,
        },
      },
      usuario: {
        nombres: null,
        apellidos: null,
        documento: {
          tipo: {
            abr: "CC",
            id: 1,
            nombre: "Cédula de Ciudadanía",
          },
          numero: null,
        },
        correo: null,
        password: null,
        telefono: null,
        urlImagen: null,
        sexo: null,
        fechaNacimiento: null,
        password: null,
      },
      origenRegistro: null,
    },
    variablesForm: {
      unidadesFrecuencia: [
        {
          id: 1,
          momentKey: "d",
          nombre: { plu: "Dias", sin: "Dia" },
          nombrePeriodicidad: "Diario",
          type: "simple",
        },
        {
          id: 2,
          momentKey: "w",
          nombre: { plu: "Semanas", sin: "Semana" },
          nombrePeriodicidad: "Semanal",
          type: "group",
          value: { idChild: 1, value: 7 },
        },
        {
          id: 3,
          nombre: { plu: "Quincenas", sin: "Quincena" },
          nombrePeriodicidad: "Quincenal",
          type: "group",
          value: { idChild: 1, value: 15 },
        },
        {
          id: 4,
          momentKey: "M",
          nombre: { plu: "Meses", sin: "Mes" },
          nombrePeriodicidad: "Mensual",
          type: "simple",
        },
        {
          id: 5,
          nombre: { plu: "Bimestres", sin: "Bimestre" },
          nombrePeriodicidad: "Bimestral",
          type: "group",
          value: { idChild: 4, value: 2 },
        },
        {
          id: 6,
          nombre: { plu: "Trimestres", sin: "Trimestre" },
          nombrePeriodicidad: "Trimestral",
          type: "group",
          value: { idChild: 4, value: 3 },
        },
        {
          id: 7,
          nombre: { plu: "Semestres", sin: "Semestre" },
          nombrePeriodicidad: "Semestral",
          type: "group",
          value: { idChild: 4, value: 6 },
        },
        {
          id: 8,
          momentKey: "y",
          nombre: { plu: "Años", sin: "Año" },
          nombrePeriodicidad: "Anual",
          type: "simple",
        },
        {
          id: 9,
          momentKey: null,
          nombre: { plu: "Cosecha", sin: "Cosecha" },
          nombrePeriodicidad: "Por Cosecha",
          type: "simple",
        },
      ],
      unidadesPeso: [
        {
          Id: "tn",
          Name: {
            Sin: {
              es: "Tonelada",
            },
            Plu: {
              es: "Toneladas",
            },
          },
          Value: 1000000,
          Unidad: {
            Name: {
              Sin: {
                es: "Gramo",
              },
              Plu: {
                es: "Gramos",
              },
            },
          },
        },
        {
          Id: "kg",
          Name: {
            Sin: {
              es: "kilogramo",
            },
            Plu: {
              es: "Kilogramos",
            },
          },
          Value: 1000,
          Unidad: {
            Name: {
              Sin: {
                es: "Gramo",
              },
              Plu: {
                es: "Gramos",
              },
            },
          },
        },
      ],
      tiposEmpresa: [
        {
          id: 2,
          slug: "catering",
          nombre: "Catering",
        },
        {
          id: 3,
          slug: "colegio",
          nombre: "Colegio",
        },
        {
          id: 11,
          slug: "comprador-institucional",
          nombre: "Comprador Institucional",
        },
        {
          id: 8,
          slug: "distribuidor",
          nombre: "Distribuidor",
        },
        {
          id: 10,
          slug: "exportador",
          nombre: "Exportador",
        },
        {
          id: 7,
          slug: "franquicia",
          nombre: "Franquicia",
        },
        {
          id: 6,
          slug: "hotel",
          nombre: "Hotel",
        },
        {
          id: 9,
          slug: "mercado",
          nombre: "Mercado",
        },
        {
          id: 4,
          slug: "procesador",
          nombre: "Procesador",
        },
        {
          id: 1,
          slug: "restaurante",
          nombre: "Restaurante",
        },
      ],
      paises: [],
      departamentos: [],
      municipios: [],
      veredas: [],
      itemsProductor: [],
      tiposDocumento: [
        { abr: "NIT", id: 6, nombre: "NIT" },
        { abr: "RC", id: 5, nombre: "Registro Civil de Nacimiento" },
        { abr: "PP", id: 3, nombre: "Pasaporte" },
        { abr: "TI", id: 4, nombre: "Tarjeta de Identidad" },
        { abr: "CE", id: 2, nombre: "Cédula de Extranjería" },
        { abr: "CC", id: 1, nombre: "Cédula de Ciudadanía" },
      ],
      sexos: [
        {
          id: 1,
          abr: "M",
          sexo: "Masculino",
        },
        {
          id: 2,
          abr: "F",
          sexo: "Femenino",
        },
        {
          id: 3,
          abr: "O",
          sexo: "Otro",
        },
      ],
    },
    rules: {
      required: (value) => !!value || "Campo Requerido",
      requiredMultiple: (value) => {
        if (value) {
          if (value.length > 0) {
            return true;
          } else {
            return "Debes seleccionar al menos un item.";
          }
        } else {
          return "Campo Requerido";
        }
      },
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "No es un email válido";
      },
      counter6: (value) => {
        if (value) {
          if (value.length == 6) {
            return true;
          } else {
            return "El código debe contener 6 digitos";
          }
        } else {
          return "Campo Requerido";
        }
      },
    },
    date: "",
    modalFechaNacimiento: false,
    showPass: false,
    origen: [
      { id: 9, nombre: "Mercados Solidarios Minuto de Dios" },
      { id: 7, nombre: "Agroredes" },
      { id: 1, nombre: "Por redes sociales" },
      { id: 2, nombre: "Por referencia de un amigo" },
      { id: 3, nombre: "Directamente por nuestra pagina" },
      { id: 4, nombre: "Buscando en Google, Bing o Yahoo" },
      {
        id: 5,
        nombre: "Por medios digitales: articulos, noticias, videos",
      },
      { id: 8, nombre: "Otro" },
      { id: "whatsapp", nombre: "Whatsapp" },
      { id: "el-campo-a-un-clic", nombre: "El Campo a un Clic" },
    ],
    loading: false,
    loadingCodigo: false,
    terminosCondiciones: false,
    dialogCodigo: false,
    dialogCodigoConfirmacion: false,
    codigoCognito: null,
    dialogErrorRegistro: false,
    snackbar: {
      show: false,
      text: null,
      color: null,
    },
    textError: "¡Hubo un error inesperado!",
  }),
  async mounted() {
    this.getProductos();
    this.variablesForm.paises = await api.getPaises();
    this.variablesForm.departamentos = await api.getDepartamentos(42);
  },
  methods: {
    async getProductos() {
      let productos = await api.getProductos();

      let productosFilt = productos.filter((prod) => {
        if (prod.tipoProducto == "agricola") {
          return true;
        }
      });

      productosFilt.sort((a, b) => {
        let comparison = 0;
        if (a.nombre > b.nombre) {
          comparison = 1;
        } else if (a.nombre < b.nombre) {
          comparison = -1;
        }
        return comparison;
      });

      this.productos = productosFilt;
    },
    continuarEmpresaStepper() {
      if (this.$refs.formProducto.validate()) {
        this.stepperRegistro = 2;
      } else {
        this.showSnackbar(
          "¡Por favor completa los campos para continuar!",
          "error"
        );
      }
    },
    //Finca
    async getCiudades(data) {
      this.nombreDept = data.nombre;
      this.variablesForm.municipios = await api.getMunicipios(
        data.id_departamento
      );
    },
    removeItem(itemEval) {
      const index = this.items.findIndex(
        (item) => item.idItem == itemEval.idItem
      );
      if (index >= 0) this.items.splice(index, 1);
    },
    continuarUsuarioStepper() {
      if (this.$refs.formFinca.validate()) {
        // let hash = this.nombreMun + " " + this.nombreDept + " Colombia";
        // this.nuevaFinca.searchUbicacion.google.hash = hash.toLowerCase();
        this.stepperRegistro = 3;
      } else {
        this.showSnackbar(
          "¡Por favor completa los campos para continuar!",
          "error"
        );
      }
    },
    //Usuario
    formatDate(val) {
      this.registroComprador.usuario.fechaNacimiento = DateTime.fromISO(
        val
      ).toString();
    },
    min(value) {
      if (value) {
        return value.length >= 6 || "La contraseña minimo debe tener 6 digitos";
      } else {
        return false;
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    async finalizarRegistro() {
      if (this.$refs.formUsuario.validate()) {
        if (this.terminosCondiciones) {

          this.loading = true;

          try {
            let data = await api.registrarComprador(this.registroComprador);
            this.loading = false;
            if (data.status) {
              this.dialogCodigo = true;
            } else {
              this.textError = data.err.msg;
              this.dialogErrorRegistro = true;
            }
          } catch (err) {
            console.log(err);
          }
        } else {
          this.loading = false;
          this.showSnackbar(
            "¡Acepta los términos y condiciones para continuar!",
            "error"
          );
        }
      } else {
        this.showSnackbar(
          "¡Por favor completa los campos para continuar!",
          "error"
        );
      }
    },
    confirmAccount() {
      this.loadingCodigo = true;
      if (this.$refs.codigoCognito.validate()) {
        let username = this.registroComprador.usuario.documento.numero.toString();
        let codigo = this.codigoCognito.toString();

        api.confirmAccount(username, codigo).then((data) => {
          this.loadingCodigo = false;
          if (data.status) {
            this.loadingCodigo = false;
            this.dialogCodigo = false;
            this.dialogCodigoConfirmacion = true;
          } else {
            this.dialogErrorRegistro = true;
            console.error(data);
          }
        });
      } else {
        this.loadingCodigo = false;
      }
    },
    volverInicio() {
      this.dialogCodigoConfirmacion = false;
      this.$router.replace({ path: "/" });
    },
    volver() {
      this.$router.push({ path: "/" });
    },
  },
  computed: {
    dateFormatted() {
      return this.date
        ? DateTime.fromISO(this.date).setLocale("es").toFormat("dd MMMM y")
        : "";
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  watch: {
    modalFechaNacimiento(val) {
      val &&
        setTimeout(() => (this.$refs.pickerBirthday.activePicker = "YEAR"));
    },
    date: "formatDate",
  },
};
</script>